import { render, staticRenderFns } from "./FormSeach.vue?vue&type=template&id=4dbc1f70&lang=pug"
import script from "./FormSeach.vue?vue&type=script&lang=js"
export * from "./FormSeach.vue?vue&type=script&lang=js"
import style0 from "./FormSeach.vue?vue&type=style&index=0&id=4dbc1f70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports